import { object, string } from "yup";

import Validations from "@src/utility/helpers/validations";
import dayjs from "dayjs";
import size from "lodash/size";
import useAxios from "@src/utility/hooks/use-axios";
import { useEffect } from "react";
import { useForm } from "react-hook-form";
import { useParams } from "react-router-dom";
import { yupResolver } from "@hookform/resolvers/yup";

export default function useMeetingsUpsert (props) {
    const { getEvents, isEdit, modalConfig, toggleModal } = props;
    const { axiosInstance, loading } = useAxios({ base: "panel" });
    const { platformId } = useParams();
    const { requiredValidation, arrayMinMaxLengthValidation } = Validations();

    const methods = useForm({
        defaultValues: {
            id         : "",
            title      : "",
            description: "",
            location   : "",
            start      : "",
            end        : "",
            attendees  : []
        },
        resolver: yupResolver(
            object({
                id         : string(),
                title      : requiredValidation({ name: "Title" }),
                description: requiredValidation({ name: "Description" }),
                location   : string(),
                start      : requiredValidation({ name: "Start" }),
                end        : requiredValidation({ name: "End" }),
                attendees  : arrayMinMaxLengthValidation({ name: "Attendees", min: 1 })
            })
        )
    });

    const { handleSubmit, reset } = methods;

    const onSubmit = async () => {
        handleSubmit(async (formData) => {
            const payload = {
                title      : formData.title,
                description: formData.description,
                start      : dayjs(formData.start).toISOString(),
                end        : dayjs(formData.end).toISOString(),
                attendees  : formData.attendees.map((att) => att.value),
                location   : formData.location,
                ...(!isEdit ? {} : { id: modalConfig.row.id })
            };
            if (isEdit) {
                await axiosInstance.put(`/calendar/${platformId}/event`, payload);
            } else {
                await axiosInstance.post(`/calendar/${platformId}/event`, payload);
            }
            getEvents();
            toggleModal();
        })();
    };

    useEffect(() => {
        if (size(modalConfig.row.title)) {
            reset({
                title      : modalConfig.row.title || "",
                description: modalConfig.row.description || "",
                location   : modalConfig.row.location || "",
                start      : modalConfig.row.start,
                end        : modalConfig.row.end,
                ...(size(modalConfig.row.attendees) && {
                    attendees:
                        modalConfig.row.attendees.map((att) => {
                            return {
                                label      : att.email,
                                value      : att.email,
                                isCreatable: true
                            };
                        }) || []
                })
            });
        } else {
            reset({
                title      : "",
                description: "",
                location   : "",
                attendees  : [],
                start      : undefined,
                end        : undefined
            });
        }
    }, [modalConfig]);

    return {
        loading,
        onSubmit,
        methods
    };
}
